<template>
  <section class="section">
    <div class="section__content --centered">
      <HeadingBlock :content="content" />
      <ul class="activity__detailed-card-group">
        <DetailedActivityCard
          :activity="activity"
          v-for="(activity, activityIndex) in activities"
          :key="activity.id"
          v-reveal="{ delay: 50 * activityIndex + 250 }"
        />
      </ul>
      <LangRouterLink
        :to="{ name: 'activities' }"
        class="button --top --centered"
        :title="content.label"
        v-reveal="{ delay: 250 }"
      >
        {{ content.label }}
      </LangRouterLink>
    </div>
  </section>
</template>

<script>
import { HeadingBlock } from '@/components/blocks'
import { DetailedActivityCard } from '@/components/cards'
import { LangRouterLink } from '@/components/global'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'UpcomingActivitiesSection',
  mixins: [DefaultSectionProps],
  components: { DetailedActivityCard, HeadingBlock, LangRouterLink },
  computed: {
    activities() {
      let activities = []
      if (this.content.items?.length) {
        activities = Array.from(this.$store.state.activities.items)
          .filter((activity) => this.content.items.includes(activity.group_id.toString()))
          .slice(0, 2)
      }

      return activities.concat(this.$store.state.activities.items.slice(0, activities.length))
    },
  },
}
</script>
